import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.scss'],
})
export class CreateRoleComponent {
  loader: boolean = false;
  edit: boolean = false;
  active: boolean = true;
  active1: boolean = false;
  url;
  id;
  item: any = {};
  name;
  description;
  code;
  allcapability: any = [];
  getUserCapability: any = [];
  userCab: any = [];
  newOrgObject:any;
  orgName;
  orgId = localStorage.getItem('organizationId');
  orgObj : any ;
  orgs=[]
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    private bottomSheet: MatBottomSheet) { }

    ionViewWillEnter() {
      sessionStorage.setItem('vendorApp','true');
      if(localStorage.getItem('dashBoardOrgId')){
        this.orgId= localStorage.getItem('dashBoardOrgId')
      }
      this.loader=true;
      sessionStorage.setItem('orgId',this.orgId)
      this.url = window.location.href;
      this.id = this.url.split('/').pop();
      
      this.service.getOrg().subscribe((res:any)=>{
        if(this.auth.checkCapability('FSA')){
          this.orgs=res;
        }else{
          this.orgs=res.filter(res=>{ return res.id==this.orgId})
        }
        this.orgs.map(res=>{
          if(res.id == this.orgId){
            this.orgName = res.name
          }
        })
      }, err => {
        this.handler.err(err);
      })
  
      this.getcapabilities();
    }
  
    save() {
      if (this.url.includes('edit-role')) {
        this.editAssess();
      }
      else {
        this.createAssess();
      }
    }
  
    editAssess() {
      this.loader = true;
      if (this.name) {
        this.name = this.name.toUpperCase();
      }
      if (this.description) {
        this.description = this.description.toUpperCase();
      }
      this.item.code = this.code;
      this.item.name = this.name;
      this.item.description = this.description;
      this.item.activeInd = this.active;
      this.item.approvalNeeded = this.active1;
      this.userCab = this.allcapability.filter(res => { return res.select == true });
      let post1: any = [];
      this.userCab.map(res => {
        post1.push({ id: res.id })
  
      })
      this.service.editRole(this.id, this.item).subscribe(res => {
        this.service.postcapabilitiesById(this.id, post1).subscribe(res => {
          this.loader = false;
          this.handler.res('Role updated successfully');
          this.router.navigate(['/manage-role']);
        }, err => {
          this.handler.err(err);
          this.loader = false;
        })
  
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
  
  
    }
  
    createAssess() {
      this.loader = true;
      if (this.name) {
        this.name = this.name.toUpperCase();
      }
      if (this.description) {
        this.description = this.description.toUpperCase();
      }
      var post = {
        name: this.name,
        description: this.description,
        code: this.code,
        activeInd: this.active,
        approvalNeeded:this.active1
      }
      this.userCab = this.allcapability.filter(res => { return res.select == true });
      let post1: any = [];
      this.userCab.map(res => {
        post1.push({ id: res.id })
  
      })
      this.service.roleCreate(post).subscribe((res: any) => {
        if (post1.length > 0) {
          this.service.postcapabilitiesById(res.roleId, post1).subscribe(res => {
            this.loader = false;
            this.handler.res('Role Created successfully');
            this.router.navigate(['/manage-role'])
          },
            err => {
              this.loader = false;
              this.handler.err(err.error);
            })
        }
        else {
          this.loader = false;
          this.handler.res('Role Created successfully');
          this.router.navigate(['/manage-role'])
        }
  
  
      },
        err => {
          this.loader = false;
          this.handler.err(err.error);
        })
    }
  
    getcapabilities() {
      this.service.getAllCapabilities().subscribe(res => {
        if (res) {
          this.allcapability = res;
          this.allcapability.map(res1 => {
            Object.assign(res1, { select: false })
          })
          if(this.url.includes('edit-role'))
            this.matchCapability()
            else
            this.loader=false;
        }
        else{
          this.loader=false;
        }
      },err=>{
        this.loader=false;
      })
  
    }
  
    select(id) {
      this.allcapability.map(res => {
        if (res.id == id) {
          res.select = !res.select;
        }
      })
    }
    ionViewWillLeave() {
      this.name = undefined;
      this.description = undefined;
      this.code = undefined;
      this.allcapability=[];
      this.userCab=[];
      this.getUserCapability=[];
      sessionStorage.clear();
      localStorage.removeItem('dashBoardOrgId');
  
    }
    matchCapability(){
        this.edit = true;
        this.loader = true;
        this.service.getAllRolesById(this.id).subscribe((res: any) => {
          this.item = res;
          this.name = res.name;
          this.description = res.description;
          this.code = res.code;
          this.active = res.activeInd;
          this.active1 = res.approvalNeeded;
          this.orgs.map(res=>{
            if(res.id=this.id){
              this.orgName=res.name
            }
          })
        }, err => {
          this.loader = false;
          this.handler.err(err)
        })
      this.service.getcapabilitiesById(this.id).subscribe((res: any) => {
        if (res!=null && res.length > 0) {
          this.getUserCapability = res;
          this.allcapability.map(data => {
            this.getUserCapability.map(data1 => {
              if (data.id == data1.id) {
                data.select = true;
              }
              this.loader = false;
            })
          })
        }
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
  
  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
      this.orgName = res.name;
      sessionStorage.setItem('orgId',res.id);
    }
     });
  }
  
}
